import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { Hooks } from '@grandvisionhq/stores-v2';
import { StoreSummary } from '../../../../../modules/ServiceStore/components/StoreSummary.js';
import { useLoggedInCheckout } from '../../../../context/context.js';
import '@grandvisionhq/lib-utils-w3c';

const ServiceStoreSummaryContainer = ({ isOrderDetailsValid , isServiceStoreValid , title , onEditHandler  })=>{
    var ref2, ref1;
    const { getLabel  } = useIntl();
    const { cart  } = Context.useCart();
    const { shippingState , setShippingState  } = useLoggedInCheckout();
    const [getStoreById, storeById] = Hooks.useStoreById();
    const storeSummary = React.useMemo(()=>{
        if (storeById.error || !storeById.data) return {
            name: '',
            streetName: '',
            streetNumber: ''
        };
        const { name , streetName , streetNumber  } = storeById.data;
        return {
            name,
            streetName,
            streetNumber
        };
    }, [
        storeById === null || storeById === void 0 ? void 0 : storeById.data,
        storeById.error
    ]);
    const loadStoreDetails = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(globalStoreId) {
            yield getStoreById({
                variables: {
                    globalStoreId
                }
            });
        });
        return function(globalStoreId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        getStoreById
    ]);
    const updateServiceStoreState = React.useCallback(()=>{
        var ref;
        ((ref = storeById.data) === null || ref === void 0 ? void 0 : ref.globalStoreId) && setShippingState(swcHelpers.objectSpread({}, shippingState, {
            serviceStore: swcHelpers.objectSpread({}, storeById.data)
        }));
    }, [
        setShippingState,
        shippingState,
        storeById.data
    ]);
    React.useEffect(()=>{
        var ref;
        if (cart === null || cart === void 0 ? void 0 : (ref = cart.serviceStore) === null || ref === void 0 ? void 0 : ref.globalStoreId) {
            loadStoreDetails(cart.serviceStore.globalStoreId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cart === null || cart === void 0 ? void 0 : (ref2 = cart.serviceStore) === null || ref2 === void 0 ? void 0 : ref2.globalStoreId
    ]);
    React.useEffect(()=>{
        var ref;
        if (storeById === null || storeById === void 0 ? void 0 : (ref = storeById.data) === null || ref === void 0 ? void 0 : ref.globalStoreId) {
            updateServiceStoreState();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        storeById === null || storeById === void 0 ? void 0 : (ref1 = storeById.data) === null || ref1 === void 0 ? void 0 : ref1.globalStoreId
    ]);
    return /*#__PURE__*/ React.createElement(StoreSummary, swcHelpers.extends({}, storeSummary, {
        actions: {
            onEdit: onEditHandler
        },
        title: title,
        errorNotification: !isServiceStoreValid ? /*#__PURE__*/ React.createElement(Alert, {
            className: "alert-m-default ",
            role: isOrderDetailsValid ? 'status' : 'alert',
            variant: isOrderDetailsValid ? 'info' : 'error',
            title: getLabel('checkout.serviceStore.incomplete.title')
        }, getLabel('checkout.information.incomplete.message')) : null
    }));
};

export { ServiceStoreSummaryContainer };
//# sourceMappingURL=ServiceStoreSummaryContainer.js.map
